<template>
  <div class="boxRegion">
    <div class="boxRegion__lable mb-8">{{ $t('label.region') }}</div>
    <div class="boxRegion__name" v-lego-tooltip:ellipsis="'Region'">{{ regionName }}</div>
  </div>
</template>

<script>
import i18nMixin from '@/mixins/i18n.mixin.js';

export default {
  mixins: [i18nMixin],
  computed: {
    regionName() {
      return this.$store.state.region.text || '';
    }
  }
};
</script>

<style scoped lang="scss">
.boxRegion {
  &__lable {
    color: var(--color-ui-13);
    font-weight: 500;
  }

  &__name {
    background-color: #f4f4f6;
    border: 1px solid var(--color-border);
    color: #454954;
    width: 100%;
    height: 32px;
    padding: 0px 12px;
    display: flex;
    align-items: center;
  }

  .boxRegion__name {
    border-radius: 2px;
  }
}
</style>
